import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatRunStarted.meta';

export type UseTrackAgentChatRunStartedParams = {
  canvas_id: string;
  thread_id: string;
  run_id?: string;
  action?: string;
};

export const useTrackAgentChatRunStarted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatRunStarted = useCallback(
    (params: UseTrackAgentChatRunStartedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatRunStarted };
};
